import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
// import ToggleGroup from 'src/components/toggle-group';
import ToggleButtonGroupWithIcon from './toggle-button-group';
import './section.scss';
import FavoritesListComponent from './favorites-list-component';
import RecentlyOpenComponent from './recently-open-component';
import StarRateIcon from '@mui/icons-material/StarRate';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';

interface ToggleOption {
  label: string;
  value: string;
  icon: string | JSX.Element;
}

export default function FavouritesRecentOpenSection({ parentHeightValue }) {
  const [selectedTab, setSelectedTab] = useState<string>('favourites');

  const toggles: ToggleOption[] = [
    {
      label: 'Favourites',
      value: 'favourites',
      icon: <StarRateIcon sx={{ fontSize: '16px' }} />
    },
    {
      label: 'Recently Opened',
      value: 'recently-opened',
      icon: <QueryBuilderIcon sx={{ fontSize: '16px' }} />
    }
  ];

  const handleToggleChange = (value: unknown) => {
    setSelectedTab(value as string);
  };

  const renderContent = () => {
    switch (selectedTab) {
      case 'favourites':
        return <FavoritesListComponent />;
      case 'recently-opened':
        return <RecentlyOpenComponent />;
      default:
        return <Skeleton variant='rectangular' width={210} height={118} />;
    }
  };

  // custom style for recently opened container
  const containerStyle = {
    backgroundImage: 'url(/static/images/Vector.png)',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom right',
    backgroundSize: '40%'
  };

  return (
    <Grid
      item
      xs='auto'
      style={selectedTab === 'recently-opened' ? containerStyle : {}}
    >
      <div className='toggle-button'>
        <ToggleButtonGroupWithIcon
          onToggle={handleToggleChange}
          toggleValue={selectedTab}
          toggles={toggles}
        />
      </div>
      <div
        style={{
          // height: parentHeightValue,
          overflow: 'auto',
          padding: '10px 16px',
          position: 'relative'
        }}
        className='section-paper-div'
      >
        {renderContent()}
      </div>
    </Grid>
  );
}
